// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Client from "@apollo/client";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation archiveVariant($id: ID!)  {\narchiveVariant(id: $id)  {\n__typename  \nid  \nformattedStatus  \narchivedAt  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.archiveVariant;
  let value$2 = value$1.formattedStatus;
  let tmp;
  switch (value$2) {
    case "ACTIVE" :
      tmp = "ACTIVE";
      break;
    case "ARCHIVED" :
      tmp = "ARCHIVED";
      break;
    case "INACTIVE" :
      tmp = "INACTIVE";
      break;
    case "VARIABLE" :
      tmp = "VARIABLE";
      break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$2
      };
  }
  let value$3 = value$1.archivedAt;
  return {
    archiveVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedStatus: tmp,
      archivedAt: !(value$3 == null) ? Scalar.Datetime.parse(value$3) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.archiveVariant;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.formattedStatus;
  let formattedStatus = typeof value$3 === "object" ? value$3.VAL : (
      value$3 === "INACTIVE" ? "INACTIVE" : (
          value$3 === "ARCHIVED" ? "ARCHIVED" : (
              value$3 === "ACTIVE" ? "ACTIVE" : "VARIABLE"
            )
        )
    );
  let value$4 = value$1.id;
  let value$5 = value$1.__typename;
  let archiveVariant = {
    __typename: value$5,
    id: value$4,
    formattedStatus: formattedStatus,
    archivedAt: archivedAt
  };
  return {
    archiveVariant: archiveVariant
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let ArchiveVariantMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let ArchiveVariantMutation_useWithVariables = include.useWithVariables;

let ArchiveVariantMutation = {
  ArchiveVariantMutation_inner: ArchiveVariantMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useWithVariables: ArchiveVariantMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation unarchiveVariant($id: ID!)  {\nunarchiveVariant(id: $id)  {\n__typename  \nid  \nformattedStatus  \narchivedAt  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.unarchiveVariant;
  let value$2 = value$1.formattedStatus;
  let tmp;
  switch (value$2) {
    case "ACTIVE" :
      tmp = "ACTIVE";
      break;
    case "ARCHIVED" :
      tmp = "ARCHIVED";
      break;
    case "INACTIVE" :
      tmp = "INACTIVE";
      break;
    case "VARIABLE" :
      tmp = "VARIABLE";
      break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$2
      };
  }
  let value$3 = value$1.archivedAt;
  return {
    unarchiveVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedStatus: tmp,
      archivedAt: !(value$3 == null) ? Scalar.Datetime.parse(value$3) : undefined
    }
  };
}

function serialize$1(value) {
  let value$1 = value.unarchiveVariant;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.formattedStatus;
  let formattedStatus = typeof value$3 === "object" ? value$3.VAL : (
      value$3 === "INACTIVE" ? "INACTIVE" : (
          value$3 === "ARCHIVED" ? "ARCHIVED" : (
              value$3 === "ACTIVE" ? "ACTIVE" : "VARIABLE"
            )
        )
    );
  let value$4 = value$1.id;
  let value$5 = value$1.__typename;
  let unarchiveVariant = {
    __typename: value$5,
    id: value$4,
    formattedStatus: formattedStatus,
    archivedAt: archivedAt
  };
  return {
    unarchiveVariant: unarchiveVariant
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$1(id, param) {
  return {
    id: id
  };
}

let UnarchiveVariantMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let UnarchiveVariantMutation_useWithVariables = include$1.useWithVariables;

let UnarchiveVariantMutation = {
  UnarchiveVariantMutation_inner: UnarchiveVariantMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useWithVariables: UnarchiveVariantMutation_useWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["mutation activateVariant($id: ID!)  {\nactivateVariant(id: $id)  {\n__typename  \nid  \nactive  \nformattedStatus  \nproduct  {\n__typename  \nid  \nformattedStatus  \n}\n\n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.activateVariant;
  let value$2 = value$1.active;
  let value$3 = value$1.formattedStatus;
  let tmp;
  switch (value$3) {
    case "ACTIVE" :
      tmp = "ACTIVE";
      break;
    case "ARCHIVED" :
      tmp = "ARCHIVED";
      break;
    case "INACTIVE" :
      tmp = "INACTIVE";
      break;
    case "VARIABLE" :
      tmp = "VARIABLE";
      break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$3
      };
  }
  let value$4 = value$1.product;
  let value$5 = value$4.formattedStatus;
  let tmp$1;
  if (value$5 == null) {
    tmp$1 = undefined;
  } else {
    let tmp$2;
    switch (value$5) {
      case "ACTIVE" :
        tmp$2 = "ACTIVE";
        break;
      case "ARCHIVED" :
        tmp$2 = "ARCHIVED";
        break;
      case "INACTIVE" :
        tmp$2 = "INACTIVE";
        break;
      default:
        tmp$2 = {
          NAME: "FutureAddedValue",
          VAL: value$5
        };
    }
    tmp$1 = tmp$2;
  }
  return {
    activateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      active: !(value$2 == null) ? value$2 : undefined,
      formattedStatus: tmp,
      product: {
        __typename: value$4.__typename,
        id: value$4.id,
        formattedStatus: tmp$1
      }
    }
  };
}

function serialize$2(value) {
  let value$1 = value.activateVariant;
  let value$2 = value$1.product;
  let value$3 = value$2.formattedStatus;
  let formattedStatus = value$3 !== undefined ? (
      typeof value$3 === "object" ? value$3.VAL : (
          value$3 === "ARCHIVED" ? "ARCHIVED" : (
              value$3 === "ACTIVE" ? "ACTIVE" : "INACTIVE"
            )
        )
    ) : null;
  let value$4 = value$2.id;
  let value$5 = value$2.__typename;
  let product = {
    __typename: value$5,
    id: value$4,
    formattedStatus: formattedStatus
  };
  let value$6 = value$1.formattedStatus;
  let formattedStatus$1 = typeof value$6 === "object" ? value$6.VAL : (
      value$6 === "INACTIVE" ? "INACTIVE" : (
          value$6 === "ARCHIVED" ? "ARCHIVED" : (
              value$6 === "ACTIVE" ? "ACTIVE" : "VARIABLE"
            )
        )
    );
  let value$7 = value$1.active;
  let active = value$7 !== undefined ? value$7 : null;
  let value$8 = value$1.id;
  let value$9 = value$1.__typename;
  let activateVariant = {
    __typename: value$9,
    id: value$8,
    active: active,
    formattedStatus: formattedStatus$1,
    product: product
  };
  return {
    activateVariant: activateVariant
  };
}

function serializeVariables$2(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$2(id, param) {
  return {
    id: id
  };
}

let ActivateVariantMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

let include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let use$2 = include$2.use;

let ActivateVariantMutation_useWithVariables = include$2.useWithVariables;

let ActivateVariantMutation = {
  ActivateVariantMutation_inner: ActivateVariantMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useWithVariables: ActivateVariantMutation_useWithVariables
};

let Raw$3 = {};

let query$3 = Client.gql(["mutation deactivateVariant($id: ID!)  {\ndeactivateVariant(id: $id)  {\n__typename  \nid  \nactive  \nformattedStatus  \nproduct  {\n__typename  \nid  \nformattedStatus  \n}\n\n}\n\n}\n"]);

function parse$3(value) {
  let value$1 = value.deactivateVariant;
  let value$2 = value$1.active;
  let value$3 = value$1.formattedStatus;
  let tmp;
  switch (value$3) {
    case "ACTIVE" :
      tmp = "ACTIVE";
      break;
    case "ARCHIVED" :
      tmp = "ARCHIVED";
      break;
    case "INACTIVE" :
      tmp = "INACTIVE";
      break;
    case "VARIABLE" :
      tmp = "VARIABLE";
      break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$3
      };
  }
  let value$4 = value$1.product;
  let value$5 = value$4.formattedStatus;
  let tmp$1;
  if (value$5 == null) {
    tmp$1 = undefined;
  } else {
    let tmp$2;
    switch (value$5) {
      case "ACTIVE" :
        tmp$2 = "ACTIVE";
        break;
      case "ARCHIVED" :
        tmp$2 = "ARCHIVED";
        break;
      case "INACTIVE" :
        tmp$2 = "INACTIVE";
        break;
      default:
        tmp$2 = {
          NAME: "FutureAddedValue",
          VAL: value$5
        };
    }
    tmp$1 = tmp$2;
  }
  return {
    deactivateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      active: !(value$2 == null) ? value$2 : undefined,
      formattedStatus: tmp,
      product: {
        __typename: value$4.__typename,
        id: value$4.id,
        formattedStatus: tmp$1
      }
    }
  };
}

function serialize$3(value) {
  let value$1 = value.deactivateVariant;
  let value$2 = value$1.product;
  let value$3 = value$2.formattedStatus;
  let formattedStatus = value$3 !== undefined ? (
      typeof value$3 === "object" ? value$3.VAL : (
          value$3 === "ARCHIVED" ? "ARCHIVED" : (
              value$3 === "ACTIVE" ? "ACTIVE" : "INACTIVE"
            )
        )
    ) : null;
  let value$4 = value$2.id;
  let value$5 = value$2.__typename;
  let product = {
    __typename: value$5,
    id: value$4,
    formattedStatus: formattedStatus
  };
  let value$6 = value$1.formattedStatus;
  let formattedStatus$1 = typeof value$6 === "object" ? value$6.VAL : (
      value$6 === "INACTIVE" ? "INACTIVE" : (
          value$6 === "ARCHIVED" ? "ARCHIVED" : (
              value$6 === "ACTIVE" ? "ACTIVE" : "VARIABLE"
            )
        )
    );
  let value$7 = value$1.active;
  let active = value$7 !== undefined ? value$7 : null;
  let value$8 = value$1.id;
  let value$9 = value$1.__typename;
  let deactivateVariant = {
    __typename: value$9,
    id: value$8,
    active: active,
    formattedStatus: formattedStatus$1,
    product: product
  };
  return {
    deactivateVariant: deactivateVariant
  };
}

function serializeVariables$3(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$3(id, param) {
  return {
    id: id
  };
}

let DeactivateVariantMutation_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};

let include$3 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3
});

let use$3 = include$3.use;

let DeactivateVariantMutation_useWithVariables = include$3.useWithVariables;

let DeactivateVariantMutation = {
  DeactivateVariantMutation_inner: DeactivateVariantMutation_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  use: use$3,
  useWithVariables: DeactivateVariantMutation_useWithVariables
};

function useArchive(id) {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback(() => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: id
  })), undefined, param => id), [id]);
}

function useUnarchive(id) {
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback(() => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: id
  })), undefined, param => id), [id]);
}

function useActivate(id) {
  let match = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback(() => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: id
  })), undefined, param => id), [id]);
}

function useDeactivate(id) {
  let match = use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  let captureEvent = SessionTracker.useCaptureEvent();
  return React.useCallback(() => Future.tapOk(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: id
  })), undefined, param => id), param => captureEvent("catalog_variant_click_deactivate")), [id]);
}

function useActivateMany() {
  let match = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback(ids => {
    if (ids.length !== 0) {
      return Future.mapOk(ApolloHelpers.mergeFutureResults(ids.map(id => ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        id: id
      })))), undefined, param => ids[0]);
    } else {
      return Future.value({
        TAG: "Ok",
        _0: undefined
      });
    }
  }, []);
}

function useDeactivateMany() {
  let match = use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  let captureEvent = SessionTracker.useCaptureEvent();
  return React.useCallback(ids => {
    if (ids.length !== 0) {
      return Future.tapOk(Future.mapOk(ApolloHelpers.mergeFutureResults(ids.map(id => ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        id: id
      })))), undefined, param => ids[0]), param => captureEvent("catalog_variant_click_deactivate"));
    } else {
      return Future.value({
        TAG: "Ok",
        _0: undefined
      });
    }
  }, []);
}

export {
  ArchiveVariantMutation,
  UnarchiveVariantMutation,
  ActivateVariantMutation,
  DeactivateVariantMutation,
  useArchive,
  useUnarchive,
  useActivate,
  useDeactivate,
  useActivateMany,
  useDeactivateMany,
}
/* query Not a pure module */
